
<template>
  <section>
    <div>
      <span class="xbed-sub-title">{{ topTitle }}</span>
    </div>

    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>营销管理</BreadcrumbItem>
        <BreadcrumbItem>活动奖励管理</BreadcrumbItem>
        <BreadcrumbItem>{{ topTitle }}</BreadcrumbItem>
      </Breadcrumb>
    </div>

    <Tabs style="margin-top:20px;" @on-click="changeTabs" v-model="currentTab">
      <TabPane label="赠送奖励" name="giveReward">
        <Row>
          <Col span="4" class="flex-col">
            <span><span style="color:red;">* </span>赠送账号：</span>
            <!-- <Button style="width:100px;margin-top:8px;" @click="importAccountFn">表格导入</Button> -->
            <!-- <Upload
              action=""
              :auto-upload="false"
              accept=".xlsx, .xls"
              :show-file-list="false"
              :on-change="handleExcel"
            >
              <Button type="success" style="width:100px;margin-top:8px;">表格导入</Button>
            </Upload> -->

            <span style="margin-top:8px;">{{ inputNumb }}/200</span>
            <span class="colorUnderline" @click="clearAccountInputFn">清空</span>
          </Col>

          <Col class="flex-col">
            <textarea style="width:580px;height:80px;padding:8px;" v-model="rewardParams.phoneListStr"
              @input="handlePhoneInputFn"></textarea>
            <span style="margin-top:8px;">* 请确保手机号已经注册Xbed会员，非会员无法获得奖励（赠送失败）</span>
            <span style="margin-top:8px;">* 多个账号时用英文符号 “,” 隔开</span>
            <!-- <span style="margin-top:8px;">* 多个账号时用英文符号 “,” 隔开，或通过表格批量导入手机号 <span class="colorUnderline">下载模板</span></span> -->
          </Col>
        </Row>

        <Row style="margin-top:40px;">
          <Col span="4">
            <span>非会员是否自动注册：</span>
          </Col>

          <RadioGroup v-model="rewardParams.isRegisterUser">
            <Radio :label="0">否</Radio>
            <Radio :label="1" style="margin-left:20px;">是</Radio>
          </RadioGroup>
        </Row>

        <Row style="margin-top:40px;">
          <Col span="4">
            <span>订单编号：</span>
          </Col>

          <Input type='text' style="width:240px;" v-model="orderNo" @on-change="hanldeChangeInput"></Input>
        </Row>
        <Row style="margin-top:40px;">
          <Col span="4">
            <span>订单实收：</span>
          </Col>
          <Col class="flex-col-item">
            <Input type='text' style="width:240px;" v-model="realPrice" @input="hanldeInput('realPrice')"></Input>
            <span>元</span>
          </Col>
        </Row>
        <Row style="margin-top:40px;">
          <Col span="4">
            <span><span style="color:red;">* </span>赠送奖励：</span>
          </Col>

          <Col class="flex-col">
            <Select v-model="rewardParams.rewardId" clearable filterable placeholder="输入下拉选择" style="width:580px;"
              @on-change="handleChange">
              <Option v-for="item in rewardList" :key="item.id" :value="item.id">{{ item.name }}</Option>
            </Select>
            <span style="margin-top:8px;">* 请确保奖励的优惠券有效且余量充足，否则无法赠送成功</span>
          </Col>
        </Row>

        <Row style="margin-top:40px;">
          <Col span="4">
            <span><span style="color:red;">* </span>赠送数量：</span>
          </Col>
          <Col class="flex-col-item">
            <Input type='text' style="width:240px;" v-model="sendCardNumber"
              @input="hanldeInput('sendCardNumber')"></Input>
            <span>张</span>
          </Col>
        </Row>

        <Row style="margin-top:40px;">
          <Col span="4">
            <span>核销卡券：</span>
          </Col>
          <Col class="flex-col">
            <textarea style="width:580px;height:80px;padding:8px;" v-model="cardNo" @input="handleCardNo"
              @blur="hanldeBlur"></textarea>
            <!-- <Input type='text' style="width:240px;" v-model="cardNo" @input="handleCardNo"
              @on-blur="hanldeBlur"></Input> -->
            <span style="margin-top:8px;" :class="[colorBol ? 'colorRed' : '']">* 当前核销数量：{{ cardNoNumber }}</span>
            <span style="margin-top:8px;">* 多个账号时用英文符号 “,” 隔开</span>
          </Col>
        </Row>

        <Row style="margin-top:40px;">
          <Col span="4">
            <span>赠送备注：</span>
          </Col>

          <Col class="flex-col">
            <textarea style="width:580px;height:80px;padding:8px;" v-model="rewardParams.remark"
              @input="handlePhoneInputFn"></textarea>
          </Col>
        </Row>

        <Row style="margin-top:40px;">
          <Col span="4">
            <span>赠送成功用户标签：</span>
          </Col>

          <Col class="flex-col">
            <Cascader :data="levelTaglist" placeholder="无" @on-change="handleTaguserFn" change-on-select
              style="width: 360px;"></Cascader>
          </Col>
        </Row>

        <Row style="margin-top:40px;">
          <Col span="4">
            <span>赠送成功发送短信：</span>
          </Col>

          <RadioGroup v-model="rewardParams.isSendMsg">
            <Radio :label="0">否</Radio>
            <Radio :label="1" style="margin-left:20px;">是</Radio>
          </RadioGroup>
        </Row>

        <Row style="margin-top:40px;" v-if="rewardParams.isSendMsg == 1">
          <Col span="4">
            <span><span style="color:red;">* </span>短信内容：</span>
          </Col>

          <Col class="flex-col">
            <textarea style="width:580px;height:80px;padding:8px;" v-model="rewardParams.msgContent"></textarea>
          </Col>
        </Row>

        <Row style="margin-top:80px;">
          <Col span="4">
          </Col>

          <Col span="4">
            <Button type="primary" style="width:120px;" @click="submitRewardFn">提交赠送</Button>
          </Col>
        </Row>
      </TabPane>

      <TabPane label="赠送记录" name="rewardRecord">
        <Form @submit.native.prevent="preventSubmit" inline>
          <FormItem label='赠送时间' :label-width='80'>
            <DatePicker v-model="defaultDate" format="yyyy-MM-dd" type="daterange" placeholder="选择日期"
              style="width: 240px"></DatePicker>
          </FormItem>

          <FormItem label='赠送奖励' :label-width='80'>
            <Input type='text' style="width:240px;" v-model="rewardInput"></Input>
          </FormItem>

          <FormItem :label-width="10">
            <Button type="primary" @click="getRewardRecordFn">查询</Button>
          </FormItem>
        </Form>

        <Page show-sizer placement="top" :total="pageParams.count" :current="pageParams.pageNum"
          :page-size="pageParams.pageSize" @on-page-size-change="changePageSize" @on-change="changePage"
          show-elevator></Page>
        <Table style="margin-top:20px;" stripe :columns="columnsList" :data='recordList' :loading='isLoading'></Table>
      </TabPane>
    </Tabs>
  </section>
</template>

<script>
import Moment from "moment";
import API from "@/api";
import Utils from "../../utils";
import xlsx from 'xlsx'
import { emojiExp } from "@/utils/regular"

export default {
  data() {
    return {
      defaultDate: [],
      levelTaglist: [],
      cardNoNumber: 0,
      currentTab: 'giveReward',
      inputNumb: 0,
      rewardList: [],
      activityReward: [],
      topTitle: '手动赠送',
      pageParams: {
        count: 0,
        pageCount: 0, //页面总数
        pageNum: 1, // 第几页
        pageSize: 10, // 每页数量
      },
      rewardParams: {
        phoneListStr: '',
        inputList: [],
        rewardId: '',
        operator: '',
        remark: '',
        isRegisterUser: 1,
        tagId: '',
        isSendMsg: 0,
        msgContent: ''
      },
      isLoading: false,
      rewardInput: '',
      orderNo: "",
      realPrice: "",
      sendCardNumber: "",
      cardNo: "",
      colorBol: true,
      bindCardNumber: "",
      recordList: [],
      columnsList: [
        {
          title: '提交赠送时间',
          key: 'createTime',
          align: 'center',
          width: 220,
          render: (h, params) => {
            let createTime = Moment(params.row.createTime).format('YYYY-MM-DD HH:mm:ss');
            return h("div", {}, createTime);
          }
        },
        {
          title: '操作人',
          key: 'operator',
          align: 'center',
          width: 120
        },
        {
          title: '赠送账号数',
          key: 'sendNum',
          align: 'center',
          width: 140
        },
        {
          title: '成功数',
          key: 'sendSucceedNum',
          align: 'center',
          width: 100
        },
        {
          title: '失败数',
          key: 'sendFailedNum',
          align: 'center',
          width: 100
        },
        {
          title: '赠送奖励',
          key: 'rewardName',
          align: 'center',
          width: 280
        },
        {
          title: '赠送备注',
          key: 'sendAwardRemark',
          align: 'center',
          width: 280
        },
        {
          title: '渠道订单号',
          // key: 'orderNo',
          align: 'center',
          width: 280,
          render: (h, params) => {
            const type = params.row.orderNo ? params.row.orderNo : "-"
            return h('span', {}, type)
          }
        },
        {
          title: '渠道实收',
          // key: 'realPrice',
          align: 'center',
          width: 280,
          render: (h, params) => {
            const type = params.row.realPrice ? Math.round(Number(params.row.realPrice) / 100).toFixed(2).toString() : "-"
            return h('span', {}, type)
          }
        },
        {
          title: '赠送券数',
          // key: 'sendCardNumber',
          align: 'center',
          width: 280,
          render: (h, params) => {
            const type = params.row.sendCardNumber ? params.row.sendCardNumber : "-"
            return h('span', {}, type)
          }
        }
      ]
    }
  },

  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.userId = Utils.findFromLocalStorage("vue-userid");
    this.env = Utils.findFromLocalStorage("env", "dev");

    // 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
    this.protHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env),
      'Authorization': Utils.findFromLocalStorage("Author-token"),
      // 'secret': '58dbac0cb9a1db115a473199f8d312e6', // 本地请求 IP 域名才需要传 secret
    }

    this.queryRewardListFn()
    this.getTagGroupAndTagFn()
  },

  mounted() {
    this.$Notice.config({
      top: 200
    });
  },

  methods: {
    hanldeChangeInput() {
      this.$nextTick(() => {
        this.orderNo = this.orderNo.trim()
      })
    },
    hanldeBlur() {
      const list = this.cardNo.split(",")
      let index = 0
      list.forEach(item => {
        if (item)
          index++
      })
      this.cardNoNumber = index
      if (this.sendCardNumber == this.cardNoNumber) {
        this.colorBol = false
      } else {
        this.colorBol = true
      }
    },
    handleCardNo() {
      this.$nextTick(() => {
        this.cardNo = this.cardNo.replace(/ |\n/g, "").replace(/，/g, ",")
      })
    },
    hanldeInput(name) {
      this.$nextTick(() => {
        if (name === 'realPrice') {
          // this[name] = this[name] ? this[name].replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') : ""
          let num = this[name].match(/\d+(\.\d{0,2})?/) ? this[name].match(/\d+(\.\d{0,2})?/)[0] : ""
          if (num[0] === '0') {
            num = ""
          }
          this[name] = num
        } else {
          this[name] = this[name] ? parseInt(this[name].replace(/[^\d]/g, "")) : ""

        }
      })
    },
    handleChange(e) {
      const obj = this.activityReward.find(item => item.rewardId === e)
      this.sendCardNumber = obj.bindCardNumber
      this.bindCardNumber = obj.bindCardNumber
    },
    async queryRewardListFn() {
      if (!Utils.hasPermission('acticityReward_list')) {
        this.$Notice.error({
          title: "无查看活动管理权限"
        });
        return
      }

      let param = {
        page: 1,
        size: 100,
        type: 3
      }

      try {
        let resp = (await API.omsAPI[this.env].clientServer.getActivityReward(param, this.protHeaders)).data;
        if (resp.retCode) {
          this.$Notice.error({
            title: '获取活动奖励列表数据异常',
            desc: resp.msg
          })
          return
        }
        this.activityReward = resp.content
        let rewardList = new Array()
        resp.content.forEach(item => {
          let acItemContent = item.rewardId + '_' + item.name + '_' + this.getActivityContent(item)
          let acItem = {
            id: item.rewardId,
            name: acItemContent
          }
          rewardList.push(acItem)
        });
        this.rewardList = rewardList
      } catch (e) {
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    },

    getActivityContent(item) {
      let text = `原价满${item.originalPrice / 100}元 `
      switch (item.type) {
        case 1:
          text += `享${item.discount / 10}折 最高减${item.maxDiscountPrice / 100}元`
          break;
        case 2:
          text += `减${item.discountPrice / 100}元`
          break;
        case 3:
          text = `赠送优惠券${item.bindCardNumber}张`
          break;
        case 5:
          text += `减房费${item.roomNight}晚 最高减${item.maxDiscountPrice / 100}元`
          break;
        default:
          break;
      }
      return text
    },

    async getTagGroupAndTagFn() {
      let params = {
        tagType: 1,
      }
      try {
        let resp = (await API.omsAPI[this.env].clientServer.getTagGroupTagList(params, this.protHeaders)).data;
        this.isloading = false
        if (resp.retCode) {
          this.$Notice.error({
            title: '获取标签用户列表数据异常',
            desc: resp.msg
          })
          return
        }
        let levelTaglist = new Array()
        for (let a = 0; a < resp.length; a++) {
          if (resp[a].tagList && resp[a].tagList.length > 0) {
            let parentItem = { label: resp[a].groupName, value: resp[a].groupId }
            let childAry = new Array()
            for (let b = 0; b < resp[a].tagList.length; b++) {
              let childItem = { label: resp[a].tagList[b].name, value: resp[a].tagList[b].id }
              childAry.push(childItem)
            }
            parentItem.children = childAry
            levelTaglist.push(parentItem)
          }
        }
        // levelTaglist.unshift(
        //   {
        //     label: "无",
        //     value: '',
        //     children:[]
        //   }
        // )
        this.levelTaglist = levelTaglist
      } catch (e) {
        this.isloading = false
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    },

    importAccountFn() {

    },

    clearAccountInputFn() {
      this.rewardParams.phoneListStr = ""
      this.rewardParams.inputList = []
      this.rewardParams = this.rewardParams
      this.inputNumb = 0
    },

    async submitRewardFn() {

      if (!Utils.hasPermission('app_marketing_activityManualRewardCreate')) {
        this.$Notice.error({
          title: "没有提交手动赠送权限"
        });
        return
      }
      if (this.rewardParams.remark) {
        console.log(this.rewardParams.remark + " : ", emojiExp.test(this.rewardParams.remark), " ; ")
        console.log("test: ", emojiExp, emojiExp.test(this.rewardParams.remark))
        console.log(typeof escape === "function" ? escape(this.rewardParams.remark) : "")
        if (emojiExp.test(this.rewardParams.remark)) {
          this.$Notice.error({
            desc: "备注存在不支持的符号，请修改"
          });
          return
        }
      }
      if (this.inputNumb > 200) {
        this.$Notice.error({
          title: "超过单次赠送账号的最大数量"
        });
        return
      } else if (this.inputNumb <= 0) {
        this.$Notice.error({
          title: "没有填写赠送账号"
        });
        return
      }
      if (!this.rewardParams.rewardId) {
        this.$Notice.error({
          title: "没有选择赠送奖励"
        });
        return
      }
      if (this.sendCardNumber == 0) {
        return this.$Notice.error({
          title: "赠送数量不能小于0"
        });

      }

      if (this.rewardParams.isSendMsg == 1 && !this.rewardParams.msgContent.trim()) {
        this.$Notice.error({
          title: "没有填写短信内容"
        });
        return
      }

      let rewardName = ''
      for (let a = 0; a < this.rewardList.length; a++) {
        if (this.rewardList[a].id == this.rewardParams.rewardId) {
          rewardName = this.rewardList[a].name
          break
        }
      }
      let params = {
        rewardId: this.rewardParams.rewardId,
        rewardName: rewardName,
        operator: this.username,
        phoneList: this.rewardParams.inputList.join(","),
        sendAwardRemark: this.rewardParams.remark,
        isRegisterUser: this.rewardParams.isRegisterUser ? true : false,
        tagId: this.rewardParams.tagId,
        isSendMsg: this.rewardParams.isSendMsg ? true : false,
        msgContent: this.rewardParams.isSendMsg ? this.rewardParams.msgContent : '',
        // orderNo: this.orderNo,
        // realPrice: this.yuanToFen(this.realPrice),
        // cardNo: this.cardNo,
        // bindCardNumber: this.recordsBindCardNumber,
        // sendCardNumber: this.sendCardNumber,
        // source: this.cardNo ? this.source : ""
      }
      const list = ['orderNo', 'realPrice', 'cardNo', 'bindCardNumber', 'sendCardNumber', 'source']
      this.argumentData(params, list)
      // if (this.orderNo) {
      //   params.orderNo = this.orderNo
      // }

      try {
        let resp = (await API.omsAPI[this.env].clientServer.submitReward(params, this.protHeaders)).data;
        if (resp.retCode) {
          this.$Modal.error({
            title: "提交失败",
            content: "<p>优惠券余量不足/优惠券已过期</p> <p>请检查调整后再试</p>",
            okText: "关闭"
          });
          return
        }
        this.clearInputSelectFn()
        this.$Modal.success({
          title: "提交成功",
          content: "<p>进度及结果请查看赠送记录</p>",
          okText: "赠送记录",
          onOk: () => {
            this.getRewardRecordFn()
            this.currentTab = "rewardRecord"
          }
        });
      } catch (e) {
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    },
    argumentData(obj, list) {
      list.forEach(item => {
        if (item === 'realPrice') {
          obj[item] = this.yuanToFen(this[item])
        }

        if (item === 'source') {
          this[item] = this.cardNo ? "97" : ""
        }
        if (this[item]) {
          obj[item] = obj[item] ? obj[item] : this[item]

        }
        if (item === 'cardNo') {
          const idx = this[item][this[item].length - 1] === "," ? this[item].length : 0
          obj[item] = idx ? obj[item] ? obj[item].substring(0, idx - 1) : "" : obj[item]
        }
        if (item === 'realPrice' && obj[item] == '0') {
          delete obj[item]
        }
      })
    },
    yuanToFen(amount) {
      return Math.round(Number(amount) * 100).toString()
    },
    clearInputSelectFn() {
      let tagId = this.rewardParams.tagId
      this.rewardParams = {
        phoneListStr: '',
        inputList: [],
        rewardId: '',
        operator: '',
        remark: '',
        isRegisterUser: 1,
        tagId: tagId,
        isSendMsg: 0,
        msgContent: ''
      }
      this.orderNo = ""
      this.realPrice = ""
      this.sendCardNumber = ""
      this.cardNo = ""
      this.colorBol = true
      this.bindCardNumber = ""
      this.inputNumb = 0
    },

    changeTabs(name) {
      if (name == "rewardRecord") {
        this.getRewardRecordFn()
      }
    },

    changePage(pageIndex) {
      this.pageParams.pageNum = pageIndex;
      this.getRewardRecordFn();
    },

    changePageSize(pageSize) {
      this.pageParams.pageNum = 1;
      this.pageParams.pageSize = pageSize;
      this.getRewardRecordFn();
    },

    async getRewardRecordFn() {
      this.isLoading = true
      let startTime = this.defaultDate[0] ? Moment(this.defaultDate[0]).format("YYYY-MM-DD 00:00:00") : '';
      let endTime = this.defaultDate[1] ? Moment(this.defaultDate[1]).format("YYYY-MM-DD 23:59:59") : '';

      let params = {
        rewardName: this.rewardInput,
        startTime: startTime,
        endTime: endTime,
        pageNum: this.pageParams.pageNum,
        pageSize: this.pageParams.pageSize
      }

      for (let key in params) {
        if (!params[key]) {
          delete params[key]
        }
      }

      let protHeaders2 = Object.assign({}, this.protHeaders)
      protHeaders2.isForm = true
      try {
        let resp = (await API.omsAPI[this.env].clientServer.getDiscountCouponRecord(params, protHeaders2)).data;
        if (resp.retCode) {
          this.$Notice.error({
            title: '获取奖励记录失败',
            desc: resp.msg
          })
          return
        }
        this.pageParams.count = resp.total
        this.recordList = resp.list
        this.isLoading = false
      } catch (e) {
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    },

    handlePhoneInputFn() {
      let inputStr = this.rewardParams.phoneListStr
      if (inputStr != null && inputStr.trim() != "") {
        let inputList = inputStr.replace(/\s*/g, '').replace(/，/g, ',').split(',').filter(i => i.trim())
        this.rewardParams.inputList = inputList
        this.inputNumb = inputList.length
      } else {
        this.inputNumb = 0
      }
    },

    handleTaguserFn(value, selectedData) {
      if (selectedData.length && selectedData.length > 1) {
        this.rewardParams.tagId = selectedData[1].value
      } else {
        this.rewardParams.tagId = ''
      }
    },

    async handleExcel(ev) {
      console.log(ev)
      let file = ev.raw
      if (!file) return
      let reader = await this.uploadExcel(file)
      const worker = xlsx.read(reader, { type: 'binary' })
      console.log(worker)
    },

    uploadExcel(file) {
      return new Promise(resolve => {
        let reader = new FileReader()
        reader.readAsBinaryString(file);
        reader.onload = ev => {
          resolve(ev.target.result)
        }
      })
    }

  }
}
</script>

<style lang="scss" scoped>
.flex-col {
  display: flex;
  flex-direction: column;
}

.flex-col-item {
  display: flex;
  align-items: center;

  span {
    padding-left: 5px;
  }
}

.colorUnderline {
  margin-top: 8px;
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.colorRed {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/marketing/activityManualReward.vue